<template>
    <div>
        <div class="col-sm-12 editor-form px-3">
            <h2 class="editor-header pt-2">
                {{ keyUpdate.id > 0 ? $t('api_keys.edit_key') : $t('api_keys.add_key') }}
            </h2>
            <div class="col-sm-12">
                <span class="span-title required">
                    {{ $t('api_keys.purpose') }}
                </span>
                <input
                    id="purpose"
                    v-model="keyUpdate.purpose"
                    type="text"
                    class="form-control form-control-sm"
                >
                <div class="nopads">
                    <span class="span-title">
                        {{ $t('api_keys.company') }}
                    </span>
                    <select
                        id="customer"
                        v-model="company"
                        class="form-select form-select-sm mb-3"
                    >
                        <option
                            :value="null"
                            disabled
                        >
                            {{ $t('users.select_company') }}
                        </option>
                        <option
                            v-for="c in companies"
                            :key="c.id"
                            :value="c.id"
                        >
                            {{ c.name }}
                        </option>
                    </select>
                </div>

                <span class="span-title required">
                    {{ $t('api_keys.type') }}
                </span>
                <select
                    id="type"
                    v-model="keyUpdate.type"
                    class="form-select form-select-sm mb-3"
                >
                    <option
                        :value="null"
                        disabled
                    >
                        {{ $t('api_keys.select_type') }}
                    </option>
                    <option :value="1">
                        {{ $t('api_keys.type_contract') }}
                    </option>
                    <option :value="2">
                        {{ $t('api_keys.type_delivery') }}
                    </option>
                    <option :value="3">
                        {{ $t('api_keys.type_gis') }}
                    </option>
                    <option :value="4">
                        {{ $t('api_keys.type_ticket') }}
                    </option>
                    <option :value="5">
                        {{ $t('api_keys.type_spreader') }}
                    </option>
                    <option :value="6">
                        Harja
                    </option>
                    <option :value="7">
                        {{ $t('api_keys.type_integration') }}
                    </option>
                    <option :value="8">
                        Louhi
                    </option>
                    <option :value="9">
                        Tiera
                    </option>
                    <option :value="10">
                        Louhi-Infra
                    </option>
                    <option :value="11">
                        {{ $t('api_keys.type_sensors') }}
                    </option>
                    <option :value="12">
                        {{ $t('api_keys.pavement_report') }}
                    </option>
                </select>


                <div
                    v-if="keyUpdate.type === 5 || keyUpdate.type === 7"
                    class="nopads"
                >
                    <span class="span-title required">
                        {{ $t('api_keys.service_provider') }}
                    </span>
                    <select
                        id="type"
                        v-model="keyUpdate.service_provider"
                        class="form-select form-select-sm mb-3"
                    >
                        <option
                            :value="null"
                            disabled
                        >
                            {{ $t('api_keys.select_service_provider') }}
                        </option>
                        <option
                            v-for="provider in serviceProviders"
                            :key="provider.value"
                            :value="provider.value"
                        >
                            {{ provider.text }}
                        </option>
                    </select>
                </div>

                <span class="span-title">
                    {{ $t('api_keys.ext_username') }}
                </span>
                <input
                    id="purpose"
                    v-model="keyUpdate.ext_username"
                    class="form-control form-control-sm"
                    type="text"
                >

                <span class="span-title">
                    {{ $t('api_keys.ext_password') }}
                </span>
                <input
                    id="purpose"
                    v-model="keyUpdate.ext_password"
                    type="text"
                    class="form-control form-control-sm"
                >

                <span class="span-title">
                    {{ $t('api_keys.ext_url') }}
                </span>
                <input
                    id="purpose"
                    v-model="keyUpdate.ext_url"
                    class="form-control form-control-sm"
                    type="text"
                >

                <span class="span-title required">
                    {{ $t('api_keys.status') }}
                </span>
                <div class="form-check">
                    <input
                        id="statusSelections"
                        v-model="statusProxy"
                        type="checkbox"
                        class="form-check-input"
                        :disabled="loading"
                    >
                    <label
                        class="form-check-label"
                        for="statusSeletions"
                    >
                        {{ keyUpdate.status === 1 ? $t('api_keys.active') : $t('api_keys.inactive') }}
                    </label>
                </div>


                <span class="span-title required">
                    {{ $t('api_keys.key') }}
                </span>
                <div class="input-group input-group-sm">
                    <input
                        id="apiKey"
                        v-model="keyUpdate.api_key"
                        :placeholder="$t('api_keys.api_key_placeholder')"
                        class="form-control form-control-sm"
                        type="text"
                    >
                </div>

                <div class="my-3">
                    <span class="span-title">
                        {{ $t('api_keys.external_api_key_title') }}
                    </span>
                    <div class="input-group input-group-sm w-100">
                        <DateTimePicker
                            :date="apiKeyExpiration"
                            :enable-time-picker="false"
                            @update:date="apiKeyExpiration = $event"
                        />
                        <button
                            class="btn btn-primary"
                            type="button"
                            :disabled="!keyUpdate.type || !company"
                            @click.stop="generateKey"
                        >
                            {{ $t('common.generate_api_key') }}
                        </button>
                    </div>
                    <div class="info-box mt-3">
                        {{ $t('api_keys.expiration') }}
                    </div>
                </div>
            </div>
            <div class="col-sm-12 button-container pb-3">
                <button
                    class="form-button btn btn-danger"
                    @click.stop="$emit('close')"
                >
                    {{ $t('common.cancel') }}
                </button>
                <button
                    class="form-button btn btn-success"
                    :disabled="formState"
                    @click.stop="submitKey"
                >
                    {{ $t('common.save') }}
                </button>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import { restApi } from '../mixins/RestApiMixin'
import { apiKeyHelper } from '../mixins/ApiKeyMixin'
import { inject } from "vue";
import DateTimePicker from '../common/DateTimePicker.vue';

export default {
    name: 'ApiKeyEditor',
    components: { DateTimePicker },
    mixins: [restApi, apiKeyHelper],
    props: {
        keyToEdit: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: 0,
            company: null,
            companies: [],
            keyUpdate: this.jsonToApiKey(this.keyToEdit),
            apiKeyExpiration: null,
            serviceProviders: [],
            spreaderServiceProviders: [
                { text: 'Arctic Machine', value: 1 },
                { text: 'Fleetlogis', value: 3 },
                { text: 'Rasco', value: 2 }
            ],
            integrationServiceProviders: [
                { text: 'Buildie', value: 1 },
            ]
        }
    },
    computed: {
        statusProxy: {
            get() {
                return this.keyUpdate.status === 1;
            },
            set(val) {
                this.keyUpdate.status = val ? 1 : 0;
            }
        },
        purposeState() {
            return !!(this.keyUpdate.purpose && this.keyUpdate.purpose.length > 2)
        },
        keyState() {
            return !!(this.keyUpdate.api_key && this.keyUpdate.api_key.length > 2)
        },
        formState() {
            return !this.purposeState || !this.keyState || !!this.loading
        }
    },
    watch: {
        'keyUpdate.type': function (val) {
            this.initServiceProviders()
        }
    },
    mounted() {
        this.fetchCompanies()
        this.initServiceProviders()
        if (this.keyUpdate.company) {
            this.company = this.keyUpdate.company.id
            this.companies.push(this.keyUpdate.company)
        }
    },
    methods: {
        generateKey() {
            const body = {
                company_id: this.company,
                type: this.keyUpdate.type,
                expires_at: this.apiKeyExpiration
            }

            this.restAdd(this.generateApiKeyUrl, body, this.generateApiKeySuccess, this.generateApieKeyFail)
        },
        generateApiKeySuccess(response) {
            this.keyUpdate.api_key = response.api_key;
        },
        generateApieKeyFail() {
            this.showAlert(this.$t('common.error'))
        },

        initServiceProviders() {
            if (this.keyUpdate) {
                const val = this.keyUpdate.type
                if (val === 5) {
                    this.serviceProviders = this.spreaderServiceProviders
                } else if (val === 7) {
                    this.serviceProviders = this.integrationServiceProviders
                } else {
                    this.serviceProviders = []
                }
            }
        },
        async fetchCompanies() {
            this.loading++;
            const { err, ...response } = await this.axios.get(this.companyUrl).catch((err) => ({ err }));
            this.loading--;
            if (err) {
                return;
            }
            this.companies = response.data;
        },
        setDefaultValues(apiKey) {
            if (!apiKey.purpose) {
                this.showAlert(this.$t('api_keys.err_purpose'))
                return
            }
            if (!apiKey.api_key) {
                this.showAlert(this.$t('api_keys.err_key'))
                return
            }
            if (this.company) {
                apiKey.company = { id: this.company }
            } else {
                this.showAlert(this.$t('api_keys.err_company'))
                return
            }
            if (apiKey.type === 5 && !apiKey.service_provider) {
                this.showAlert(this.$t('api_keys.err_service_provider'))
                return
            }
            return apiKey
        },
        submitKey() {
            var jsonApiKey = this.setDefaultValues(this.keyUpdate)
            if (jsonApiKey === undefined) {
                return;
            }
            this.loading++;

            if (jsonApiKey.id < 1) {
                this.restAdd(this.apiKeyUrl, jsonApiKey, this.success, this.fail)
            } else {
                this.restUpdate(this.apiKeyUrl, jsonApiKey, this.success, this.fail)
            }
        },
        success() {
            this.loading--
            this.$emit('closeAndUpdate')
        },
        fail() {
            this.loading--
            this.showAlert(this.$t('common.alert_update_failed'));
        },
    }
}
</script>
